<template>
  <div class="rightPublicTable" v-loading="loading">
    <div class="header">
      <span class="title">人员列表</span>
    </div>
    <div class="operations">
      <el-button size="small"  type="danger" plain :disabled="!selectRows[0]" @click="delRows(selectRows)" v-if="checkAuth('dele')">批量删除</el-button>
    </div>
    <div class="tableList">
      <el-table :data="tableData" height="100%" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column align="center" type="selection" width="150"> </el-table-column>
        <el-table-column prop="name" label="姓名" width="180"> </el-table-column>
        <el-table-column align="center" prop="phone" label="手机号" width="180"> </el-table-column>
        <el-table-column align="center" prop="email" label="邮箱" width="180"> </el-table-column>
        <el-table-column label="性别" prop="sex" width="80" align="center">
          <template #default="{row}">
            <span v-if="row.sex=='1'">男</span>
            <span v-if="row.sex=='2'">女</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip align="center" v-if="type === 'interior'" prop="department" label="部门"> </el-table-column>
        <el-table-column show-overflow-tooltip v-if="type === 'external'" prop="company" label="公司名称" align="center"> </el-table-column>
        <!-- <el-table-column align="center" prop="role" label="所属角色"> </el-table-column> -->
        <el-table-column align="center" prop="address" label="操作">
          <template slot-scope={row}>
            <el-button type="text" @click="openDetail(row)">查看</el-button>
            <el-button type="text" @click="delRows([row])" v-if="checkAuth('dele')">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <personDetail ref="personDetail" :type="type"></personDetail>
  </div>
</template>

<script>
import request from '@/xgzdService/prjMember-service'
import personDetail from './personDetail/personDetail'
import { checkAuth } from '../utils'

export default {
  name:'rightPublicTable',

  props:['type'],

  data () {
    return {
      tableData:[],
      loading:false,
      selectRows:[],
      currentTreeData:{},
    }
  },

  components : {
    personDetail
  },

  methods:{
    checkAuth,
    /**
     * 查询成员列表
     * @param data
     */
    updateList (data) {
      this.loading = true
      this.currentTreeData = data
      if (this.type === 'interior') {     //内部
        this.queryInteriorPersonList(data)
      } else {  //外部
        this.queryExternalPersonList(data)
      }
    },

    /**
     * 查询内部成员列表
     * @param prjId  项目id
     * @param roleId 角色id
     * @returns {Promise<ElMessageComponent>}
     */
    async queryInteriorPersonList ({prjId, roleId }) {
      try {
        const res = await request.queryInteriorPersonList(prjId,roleId)
        if (res.result !== '0') return this.$message.warning('查询成员列表失败')
        this.tableData = res.data || []
        this.loading = false
      } catch (e) {
        this.loading = false
        this.$message.warning(e.message || '查询成员列表失败')
      }
    },

    /**
     * 查询外部成员列表
     * @param prjId  项目id
     * @param roleId 角色id
     * @returns {Promise<ElMessageComponent>}
     */
    async queryExternalPersonList ({prjId, roleId }) {
      try {
        const res = await request.queryExternalPersonList(prjId,roleId)
        if (res.result !== '0') return this.$message.warning('查询成员列表失败')
        this.tableData = res.data || []
        this.loading = false
      } catch (e) {
        this.loading = false
        this.$message.warning(e.message || '查询成员列表失败')
      }
    },

    async delRows (rows) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const roleStaffIdList = rows.map(item => item.roleStaffId)
        const requestType = this.type === 'interior' ? 'delInteriorPerson' : 'delExternalPerson'
        const res = await request[requestType]({roleStaffIdList})
        if (res.result === '0') {
          this.updateList(this.currentTreeData)
        }
      }).catch(() => {});
    },

    openDetail (row) {
      this.$refs.personDetail.queryDetail(row)
      this.$refs.personDetail.dialogVisible = true
    },

    handleSelectionChange (value) {
      this.selectRows = value
    },
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.rightPublicTable
  width 83%
  height 100%

  .header
    height 56px
    display flex
    align-items center
    padding 0 15px
    box-sizing border-box
    border-bottom: 1px solid #E5E8F1

    .title
      font-weight 600
      font-size 14px
  .operations
    height 40px
    display flex
    align-items center
    padding 0 20px
    box-sizing border-box

  .tableList
    height calc(100% - 97px)
</style>
